<template>
    <a-card title="投资机构基本信息">
        <div class="border-t">
            <a-form ref="ruleForm" :model="form" :rules="rules" :isModal="false">
                <!--可编辑区域 start-->
                <div class="hidden">
                    <a-form-item label="id" name="id">
                        <a-input v-model:value="form.id" />
                    </a-form-item>
                </div>
                <a-col class="hidden" :span="12">
                    <a-form-item label="审核状态：0 待审核，1 审核通过，2 审核未通过" name="auditStatus">
                        <a-input v-model:value="form.auditStatus" placeholder="请输入审核状态：0 待审核，1 审核通过，2 审核未通过" />
                    </a-form-item>
                </a-col>
                <table class="my-table">
                    <tbody>
                        <tr>
                            <td colspan="24">
                                <a-form-item label="机构logo" name="logo">
                                    <img-upload v-model:value="form.logo" />
                                </a-form-item>
                            </td>
                        </tr>

                        <tr>
                            <td colspan="12">
                                <a-form-item label="机构名称" name="institutionsName">
                                    <a-input v-model:value="form.institutionsName" placeholder="请输入机构名称" />
                                </a-form-item>
                            </td>

                            <td colspan="12">
                                <a-form-item label="邮箱" name="email">
                                    <a-input v-model:value="form.email" placeholder="请输入机构类型" />
                                </a-form-item>
                            </td>
                        </tr>

                        <tr>
                            <td colspan="12">
                                <a-form-item label="公司网址" name="companyWebSite">
                                    <a-input v-model:value="form.companyWebSite" placeholder="请输入公司网址" />
                                </a-form-item>
                            </td>
                            <td colspan="12">
                                <a-form-item label="投资金额" name="investmentAmount">
                                    <a-input-number v-model:value="form.investmentAmount" placeholder="请输入投资金额" />
                                </a-form-item>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="12">
                                <a-form-item label="投资阶段" name="investmentStage">
                                    <DictSelect
                                        v-model:value="form.investmentStage"
                                        :dict-name="financeDict.PROJECTSTAGE"
                                        placeholder="请选择"
                                    />
                                </a-form-item>
                            </td>
                            <td colspan="12">
                                <a-form-item label="投资领域" name="investmentField">
                                    <multiple-select v-model:value="form.investmentField" :options="options" title-name="name" value-name="id"/>
                                </a-form-item>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="12">
                                <a-form-item label="地区" name="prov">
                                    <city-select v-model:prov="form.prov" v-model:city="form.city" v-model:dist="form.dist"
                                        placeholder="请选择省/市/区" />
                                </a-form-item>
                            </td>
                            <td colspan="12">
                                <a-form-item label="详细地址" name="address">
                                    <a-input v-model:value="form.address" placeholder="请输入详细地址" />
                                </a-form-item>
                            </td>
                        </tr>
                        <tr>

                            <td colspan="8">
                                <a-form-item label="统一社会信用代码" name="unifiedSocialCreditCode">
                                    <a-input v-model:value="form.unifiedSocialCreditCode" placeholder="请输入统一社会信用代码" />
                                </a-form-item>
                            </td>
                            <td colspan="8">
                                <a-form-item label="注册时间" name="registrationTime">
                                    <date-picker v-model:value="form.registrationTime" placeholder="请输入注册时间"/>
                                </a-form-item>
                            </td>
                            <td colspan="8">
                                <a-form-item label="法人代表" name="legalPerson">
                                    <a-input v-model:value="form.legalPerson" placeholder="请输入法人代表" />
                                </a-form-item>
                            </td>
                        </tr>
                        <tr>

                            <td colspan="8">
                                <a-form-item label="联系人" name="contacts">
                                    <a-input v-model:value="form.contacts" placeholder="请输入联系人" />
                                </a-form-item>
                            </td>
                            <td colspan="8">
                                <a-form-item label="联系人职务" name="post">
                                    <a-input v-model:value="form.post" placeholder="请输入联系人职务" />
                                </a-form-item>
                            </td>
                            <td colspan="8">
                                <a-form-item label="联系人电话" name="contactNumber">
                                    <a-input v-model:value="form.contactNumber" placeholder="请输入联系人电话" />
                                </a-form-item>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="24">
                                <a-form-item label="机构简介" name="briefIntroduction">
                                    <a-textarea v-model:value="form.briefIntroduction" placeholder="请输入机构简介"
                                        :auto-size="{ minRows: 5, maxRows: 6 }" />
                                </a-form-item>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <!--可编辑区域 end-->
                <div class='text-center mt-20'>
                    <a-button type="primary" @click="onSubmit">保存</a-button>
                </div>
            </a-form>
        </div>
    </a-card>
</template>
<script>
import { formMixin } from "@/mixins";
import {common_controller} from "@/api/commonService";
import { financeDict } from "@/config/variableConfig";
import { financeMechanism } from "@/api/finance";
  import DictSelect from "@/components/other/DictSelect";
import dataCheck from "@/utils/dataCheck";

export default {
    name: "companyInfo",
    components: {
        DictSelect
    },
    mixins: [formMixin],
    data() {
        return {
            financeDict,
            options:[],
            form: {
                id: null,
                institutionsName: null,
                email: null,
                investmentField: null,
                investmentStage: null,
                companyWebSite: null,
                investmentAmount: null,
                prov: null,
                city: null,
                dist: null,
                address: null,
                logo: null,
                unifiedSocialCreditCode: null,
                registrationTime: null,
                legalPerson: null,
                contacts: null,
                post: null,
                contactNumber: null,
                auditStatus: null,
                briefIntroduction: null,
            },
            rules: {
                id: [],
                institutionsName: [dataCheck.required({})],
                email: [dataCheck.required({})],
                investmentField: [dataCheck.required({})],
                companyWebSite: [dataCheck.required({})],
                investmentAmount: [dataCheck.required({type:'number'}),dataCheck.number],
                investmentStage: [dataCheck.required({})], 
                prov: [dataCheck.required({})],
                city: [dataCheck.required({})],
                dist: [dataCheck.required({})],
                address: [dataCheck.required({})],
                logo: [],
                unifiedSocialCreditCode: [dataCheck.required({})],
                registrationTime: [dataCheck.required({})],
                legalPerson: [dataCheck.required({})],
                contacts: [dataCheck.required({})],
                post: [dataCheck.required({})],
                contactNumber: [dataCheck.required({}),dataCheck.phone],
                auditStatus: [],
                briefIntroduction: [dataCheck.required({})],
            },
        }
    },
    computed: {
            submitUrl() {
                if (this.form.id) {
                    return financeMechanism.edit
                } else {
                    return financeMechanism.add
                }
            }
        },
    created() {
        this.getDict(),
        this.getCorpInfo()
    },
    methods: {
        getDict(){
            this.getAction({
                url:common_controller.getDictDataByGroupNumber,
                params: {
                    groupNumbers: "investmentfield"
                }
            }).then(res=>{
                this.options = res
            })
        },
        getCorpInfo() {
            this.getAction({
                url: financeMechanism.detail
            }).then(res => {
                if(res){
                    this.form = res
                }
                // console.log(this.form)
            })
        },
    },
}
</script>
<style lang="less" scoped>
.border-t {
    border-width: 1px;
    border-style: solid;
    border-color: #dedede;
    border-width: 0;
    border-top-width: 1px;

    .inline-form {
        .ant-form-item {
            display: flex
        }

        .ant-form-item-control-wrapper {
            flex: 1;
        }
    }

    .my-table {
        table-layout: fixed;

        td {
            border: 1px solid #dedede;
            padding: 15px;
        }

        .ant-form-item {
            margin-bottom: 0;
        }
    }
}
</style>